export const collectionFaqs = () => {

  const $collectionFaqsSection = document.querySelector(".collection-faqs");
  if ($collectionFaqsSection) {
    const $contentsFaqs =
      $collectionFaqsSection.querySelector(".contents__faqs");
    if ($contentsFaqs) {
      const $fieldItems = $contentsFaqs.querySelectorAll(".faq");
      if ($fieldItems) {
        $fieldItems.forEach(($fieldItem) => {
          const $faqButton = $fieldItem.querySelector(".faq__button");
          const $buttonArrow = $faqButton.querySelector(".button__arrow");
          const $faqContents = $fieldItem.querySelector(".faq__contents");

          if ($faqButton && $buttonArrow && $faqContents) {
            $faqButton.addEventListener("click", () => {
              if ($fieldItem.classList.contains("faq--active")) {
                $fieldItem.classList.remove("faq--active");
              } else {
                $fieldItem.classList.add("faq--active");
              }
            });
          }
        });
      }
    }
  }
};

export default collectionFaqs;
